import { Injectable } from '@angular/core';
// import { DashboardQuota } from '@purespectrum1/ui/marketplace/shared/interfaces/manage-quotas.interface';
import { Socket } from 'ngx-socket-io';

import {
  DashboardChannel,
  // SupplierSurveyStartChannel,
  // SupplierChannel,
} from './../buyer-api/survey.interface';
import {
  BuyerProgressChannelV3,
  SurveyStatusChange,
  SurveyCompletesChange,
  SurveyScoreChange,
  // QuotaCPIChange,
  // QbsCTUpdate,
} from './socket.interface';
@Injectable({
  providedIn: 'root',
})
export class SocketService {
  subscribeToSurveys(surveyIds: number[]) {
    this._socket.emit('subscribeToSurveys', { surveyIds: surveyIds });
  }

  unsubscribeFromSurveys(surveyIds: number[]) {
    this._socket.emit('unsubscribeFromSurveys', { surveyIds: surveyIds });
  }

  joinSurveyRoom(surveyId: number | undefined) {
    this._socket.emit('joinSurveyRoom', surveyId);
  }

  leaveSurveyRoom(surveyId: number | undefined) {
    this._socket.emit('leaveSurveyRoom', surveyId);
  }

  // dashboard channel is used in survey listing(dashboard component) and survey-detail component
  dashboardChannel$ = this._socket.fromEvent<DashboardChannel>('dashboard');

  // buyerProgressChannelV3 channel is used in survey listing(dashboard component) only
  buyerProgressChannelV3$ = this._socket.fromEvent<BuyerProgressChannelV3>(
    'buyerProgressChannelV3'
  );

  // surveyStatusChange channel is used in survey listing(dashboard component) only
  surveyStatusChange$ =
    this._socket.fromEvent<SurveyStatusChange>('surveyStatusChange');

  // surveyCompletes channel is used in survey-detail component only
  surveyCompletes$ =
    this._socket.fromEvent<SurveyCompletesChange>('surveyCompletes');

  // surveyScoreChange channel is used in survey-detail component only
  surveyScoreChange$ =
    this._socket.fromEvent<SurveyScoreChange>('surveyScoreChange');

  constructor(private _socket: Socket) {}
}
